module.exports = __webpack_public_path__ + "img/tuxsuite.d8a9bc27.svg";